import animalAlertPopoverSlice from './slice';

export const { openAnimalAlertPopover, closeAnimalAlertPopover, toggleAnimalAlertPopover } = animalAlertPopoverSlice.actions;
